var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBlogIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1194_438)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.9933 15.3121C11.3333 15.3121 11.609 15.0365 11.609 14.6965C11.609 14.3565 11.3333 14.0809 10.9933 14.0809C10.6533 14.0809 10.3777 14.3565 10.3777 14.6965C10.3777 15.0365 10.6533 15.3121 10.9933 15.3121Z",
    fill: "#2DB400"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.0364 15.3372C17.3972 15.3372 17.6897 15.0447 17.6897 14.6839C17.6897 14.3231 17.3972 14.0306 17.0364 14.0306C16.6756 14.0306 16.3831 14.3231 16.3831 14.6839C16.3831 15.0447 16.6756 15.3372 17.0364 15.3372Z",
    fill: "#2DB400"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.5142 8H9.48566C8.17903 8 7.11111 9.06792 7.11111 10.3745V18.1012C7.11111 19.4204 8.17903 20.4758 9.48566 20.4758H14.084L15.6544 24.1821C15.6544 24.1821 15.7675 24.4962 16.0188 24.4962C16.2826 24.4962 16.3831 24.1821 16.3831 24.1821L17.9536 20.5009H22.5142C23.8334 20.5009 24.8888 19.433 24.8888 18.1264V10.3745C24.9013 9.06792 23.8334 8 22.5142 8ZM12.702 14.8347C12.6894 16.2418 11.232 16.2921 11.232 16.2921C10.6666 16.2921 10.3526 15.9151 10.3526 15.9151V16.1664H9.28464V11.7817C9.34746 11.7942 10.3526 11.7817 10.3526 11.7817V13.4652C10.6038 13.0381 11.3325 13.0506 11.3325 13.0506C12.8904 13.1888 12.702 14.8347 12.702 14.8347ZM14.574 13.1763V16.179H13.5312V13.2014C13.5312 12.7993 13.0286 12.6863 13.0286 12.6863V11.6309C14.687 11.7063 14.574 13.1763 14.574 13.1763ZM17.0365 16.2921C16.069 16.2921 15.2901 15.5759 15.2901 14.6839C15.2901 13.7919 16.069 13.0757 17.0365 13.0757C18.0039 13.0757 18.7828 13.7919 18.7828 14.6839C18.7828 15.5759 18.0039 16.2921 17.0365 16.2921ZM22.753 16.2921C22.753 16.2921 22.7655 17.8248 21.2202 17.8248H20.7428V16.8323H21.0317C21.0317 16.8323 21.685 16.8951 21.6725 15.89C21.6725 15.89 21.5468 16.2921 20.6297 16.2921C20.6297 16.2921 19.3356 16.2041 19.3356 14.9352V14.4578C19.3356 14.4578 19.3607 13.1511 20.793 13.0381C20.793 13.0381 21.3584 12.9752 21.6976 13.4401V13.1134H22.753V16.2921Z",
    fill: "#2DB400"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.0945 15.3247C21.4484 15.3247 21.7353 15.0378 21.7353 14.6839C21.7353 14.33 21.4484 14.0432 21.0945 14.0432C20.7406 14.0432 20.4538 14.33 20.4538 14.6839C20.4538 15.0378 20.7406 15.3247 21.0945 15.3247Z",
    fill: "#2DB400"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1194_438"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlogIcon);
export default __webpack_public_path__ + "static/media/blog-icon.ad2e25502a07597d39cbc72a01ebdf5b.svg";
export { ForwardRef as ReactComponent };